import React from 'react';

interface RoundTable {
    id: number;
    name: string;
    number: number;
    iban: string;
    bic: string;
    kontoInhaber: string;
    bankName: string;
    billingName: string;
    billingEmail: string;
    billingPlz: string;
    billingCity: string;
    billingStreet: string;
    billingStreetNumber: string;
}

interface RoundTableInfoCardProps {
    roundTable: RoundTable;
}

const RoundTableInfoCard: React.FC<RoundTableInfoCardProps> = ({ roundTable }) => {
    return (
        <div className="roundtable-info-card">
            <h2>Round Table Informationen</h2>
            <div className="roundtable-details">
                <div className="roundtable-section">
                    <h3>Allgemeine Informationen</h3>
                    <div className="info-grid">
                        <div className="info-item">
                            <span className="info-label">Name:</span>
                            <span className="info-value">{roundTable.name}</span>
                        </div>
                        <div className="info-item">
                            <span className="info-label">Nummer:</span>
                            <span className="info-value">{roundTable.number}</span>
                        </div>
                    </div>
                </div>
                
                <div className="roundtable-section">
                    <h3>Bankverbindung</h3>
                    <div className="info-grid">
                        <div className="info-item">
                            <span className="info-label">Kontoinhaber:</span>
                            <span className="info-value">{roundTable.kontoInhaber}</span>
                        </div>
                        <div className="info-item">
                            <span className="info-label">Bank:</span>
                            <span className="info-value">{roundTable.bankName}</span>
                        </div>
                        <div className="info-item">
                            <span className="info-label">IBAN:</span>
                            <span className="info-value">{roundTable.iban}</span>
                        </div>
                        <div className="info-item">
                            <span className="info-label">BIC:</span>
                            <span className="info-value">{roundTable.bic}</span>
                        </div>
                    </div>
                </div>
                
                <div className="roundtable-section">
                    <h3>Rechnungsadresse</h3>
                    <div className="info-grid">
                        <div className="info-item">
                            <span className="info-label">Name:</span>
                            <span className="info-value">{roundTable.billingName}</span>
                        </div>
                        <div className="info-item">
                            <span className="info-label">E-Mail:</span>
                            <span className="info-value">{roundTable.billingEmail}</span>
                        </div>
                        <div className="info-item">
                            <span className="info-label">Straße:</span>
                            <span className="info-value">
                                {roundTable.billingStreet} {roundTable.billingStreetNumber}
                            </span>
                        </div>
                        <div className="info-item">
                            <span className="info-label">PLZ / Ort:</span>
                            <span className="info-value">
                                {roundTable.billingPlz} {roundTable.billingCity}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RoundTableInfoCard;
